import React, { Suspense, useEffect } from 'react';
import { CSpinner, useColorModes } from '@coreui/react';
import { BrowserRouter, Route, Routes } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { MerchantProvider } from './components/Context/MerchantContext';
import { UploadedFilesProvider } from './components/Context/UploadedFilesContext';
import ProtectedRoute from './components/Context/protectedRoute';
import { UserRoleProvider } from './components/Context/useRoleContext';
import InactivityHandler from './hooks/useInactivityLogout';
import ChangePassword from './views/pages/login/ChangePassword';
import ResetPasswordScreen from './views/pages/login/ResetPassword';
import './scss/style.scss';
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

// Containers
const DefaultLayout = React.lazy(() => import('./layout/DefaultLayout'));

// Pages
const Login = React.lazy(() => import('./views/pages/login/Login'));
const ForgotPassword= React.lazy(() => import('./views/pages/login/ForgotPassword'));
//const ResetPassword= React.lazy(() => import('./views/pages/login/ResetPassword'));
const VerifyOTP = React.lazy(() => import('./views/pages/login/VerifyOTP'));
const Register = React.lazy(() => import('./views/pages/register/Register'));
const Page404 = React.lazy(() => import('./views/pages/page404/Page404'));
const Page500 = React.lazy(() => import('./views/pages/page500/Page500'));
// const Files = React.lazy(() => import('./views/pages/FileCleaning/files'))

const App = () => {
  const { isColorModeSet, setColorMode } = useColorModes('coreui-free-react-admin-template-theme');
  const storedTheme = useSelector((state) => state.theme);

  useEffect(() => {
    const urlParams = new URLSearchParams(window.location.href.split('?')[1]);
    const theme = urlParams.get('theme') && urlParams.get('theme').match(/^[A-Za-z0-9\s]+/)[0];
    if (theme) {
      setColorMode(theme);
    }

    if (isColorModeSet()) {
      return;
    }

    setColorMode(storedTheme);
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  return (
    <UploadedFilesProvider>
      <UserRoleProvider>
        <MerchantProvider>
          <BrowserRouter>
          <ToastContainer position="top-right" autoClose={5000} />
            <Suspense
              fallback={
                <div className="pt-3 text-center">
                  <CSpinner color="primary" variant="grow" />
                </div>
              }
            >
              <InactivityHandler>
                <Routes>
                  <Route exact path="/login" name="Login Page" element={<Login />} />
                  <Route exact path="/change-password" name="Change Password" element={<ChangePassword />} />
                  <Route exact path="/forgot-password" name="Forgot Password" element={<ForgotPassword />} />
                  <Route exact path="/reset-password" name="Reset Password" element={<ResetPasswordScreen />} />

                  <Route exact path="/verify-otp" name="Verify OTP Page" element={<VerifyOTP />} />
                  <Route exact path="/register" name="Register Page" element={<Register />} />
                  <Route exact path="/merchant" name="Register Page" element={<Register />} />
                  <Route exact path="/404" name="Page 404" element={<Page404 />} />
                  <Route exact path="/500" name="Page 500" element={<Page500 />} />
                  <Route exact path="/" name="Home" element={<Login />} />
                  <Route path="*" name="Landing" element={<ProtectedRoute><DefaultLayout /></ProtectedRoute>} />
                </Routes>
              </InactivityHandler>
            </Suspense>
          </BrowserRouter>
        </MerchantProvider>
      </UserRoleProvider>
    </UploadedFilesProvider>
  );
};

export default App;